import { getVerticalPlaylist, getViewportWidth, hasContextualVideo } from './module/inject-common';
import { log } from './module/log';
import { pixelsInject } from './module/outstream-pixels';
import { shortsLoader } from './shorts-module-loader';

pixelsInject('').setPubId('siamsport');
if (__ENV_MODE__ === 'prod') {
  pixelsInject('').setPlaylist('cf1470b2-53d5-4977-a121-9f60b32c3db4');
}

const siamsportInject: InjectPixelsLegacy = selector => {
  return {
    setup: async (options, callback) => {
      let result = false;
      if (getViewportWidth() <= 480) {
        log('pixels', 'vertical...');
        const publisherId = 'siamsport';
        const playlistId = 'not-available';
        const pixelsPageId = options.pageId;
        const playlistVideo = await getVerticalPlaylist(pixelsPageId, publisherId, playlistId);
        if (playlistVideo.length && hasContextualVideo(playlistVideo)) {
          log('pixels', 'has vertical playlist with contextual video...', playlistVideo);
          // render mobile-only vertical player...
          shortsLoader(selector, publisherId, playlistId, playlistVideo);
          result = true;
        }
      } else {
        result = await pixelsInject(selector).setup(options);
      }
      callback && callback(result);
    },
  };
};

window.pixelsInject = siamsportInject;
